export default "__VITE_ASSET__DbBgqms9__"